import { Button, icon } from "@hm/fundamental"

interface CalendarNavigationProps {
	viewMode: "months" | "days"
	currentYear: number
	currentMonth: number
	monthNames: string[]
	onPrev: () => void
	onNext: () => void
	"data-cy": string
}

export const CalendarNavigation: React.FC<CalendarNavigationProps> = ({
	viewMode,
	currentYear,
	currentMonth,
	monthNames,
	onPrev,
	onNext,
	"data-cy": dataCy,
}) => {
	return (
		<div className="flex items-center justify-between mb-3">
			<Button
				square
				variant="tertiary"
				icon={icon.mdiChevronLeft}
				onClick={onPrev}
				aria-label="Previous"
				data-cy={`${dataCy}-prev`}
			/>
			<span className="text-base font-medium">
				{viewMode === "months"
					? currentYear
					: `${monthNames[currentMonth]} ${currentYear}`}
			</span>
			<Button
				square
				variant="tertiary"
				icon={icon.mdiChevronRight}
				onClick={onNext}
				aria-label="Next"
				data-cy={`${dataCy}-next`}
			/>
		</div>
	)
}
